// extracted by mini-css-extract-plugin
export var inputContainer = "_s2-0";